var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-preview-container"},[_c('div',[_c('uploader',{staticClass:"upload",attrs:{"limit":9},model:{value:(_vm.document_pic),callback:function ($$v) {_vm.document_pic=$$v},expression:"document_pic"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }